import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';

export default class TpCreditMemoLineSearchParams extends SearchParamsBase {
  static saveType = 'TpCreditMemoLineSearchParams';
  initialize() {
    this.TpCreditMemoId = 0;
    this.TpJobThirdPartyIds = '';
    this.UseCompletedDateRange = false;
    this.CompletedAfter = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.CompletedBefore = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SelectedCountries = [];
    this.SelectedOfficeIds = [];
    this.SelectedThirdPartyJobStatuses = [];
    this.AdHocGroup = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'TpJobThirdPartyIds',
      label: 'Assignment Third-Party IDs',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'UseCompletedDateRange',
      label: 'Completed Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CompletedAfter',
      label: 'Completed On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'CompletedBefore',
      label: 'Completed On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedThirdPartyJobStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    {
      fieldName: 'AdHocGroup',
      label: 'Ad-Hoc Invoice Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
  ];
}
